import CheckboxCell from "../../../common/interactive/CheckboxCell"
import { useEffect, useState } from "react"

export default function CheckBoxMultiArrayOption({filtersValues, item, options, mainSelectAction, workQ, classes}) {

    const [selectedOptions, setSelectedOptions] = useState([])

    function onChangeHandler(value) {
        setSelectedOptions(prevState => [...prevState, value.identifier.field])

        if (mainSelectAction) {
            mainSelectAction({
                data: {
                    value: [...selectedOptions, value.identifier.field]
                },
                identifier: {type: item.key}
            })
            
        }
    }

    // useEffect(() => {
    //     setSelectedOptions(filtersValues && filtersValues[item.key] && filtersValues[item.key].map(item => item.value))
    // }, [filtersValues])

    return <div className={`${classes.row} ${classes.checkbox_multi_array_option_container}`}>
        <div className={classes.checkbox_multi_array_option_container_inner}>
            {options.map(option => (
                <div key={option.value} className={classes.checkbox_multi_array_option}>
                    <CheckboxCell checked={selectedOptions.includes(option.value)} label={option.label} name={option.value} identifier={{type: item.key, field: option.value}} direction={'reverse'} action={onChangeHandler}/>
                </div>
            ))}
        </div>
    </div>
}